import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_98738aa4-d15a-49a5-91ed-b440272a52f8/artifacts/7wqqh2d2_545628516_1346832964111910_2241672968598432666_n__1_-removebg-preview.png";

const quickLinks = [
  { path: "/", label: "Acasa" },
  { path: "/despre-noi", label: "Despre Noi" },
  { path: "/servicii", label: "Servicii" },
  { path: "/galerie", label: "Galerie Foto" },
  { path: "/faq", label: "FAQ" },
  { path: "/contact", label: "Contact" },
];

export default function Footer() {
  return (
    <footer className="bg-[#050505] border-t border-white/10 pt-16 pb-8" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-3 gap-12 mb-12">
          {/* Brand */}
          <div>
            <img src={LOGO_URL} alt="LSK Auto Styling" className="h-16 mb-4" />
            <p className="text-white font-light text-sm leading-relaxed" style={{ fontFamily: "'Raleway', sans-serif" }}>
              Centru premium de detailing auto în Râmnicu Sărat.
              Oferim servicii de cea mai înaltă calitate pentru mașina ta.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4
              className="text-sm tracking-[0.2em] uppercase mb-6 text-red-600 font-semibold"
              style={{ fontFamily: "'Raleway', sans-serif" }}
            >
              Link-uri Rapide
            </h4>
            <div className="flex flex-col gap-3">
              {quickLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  data-testid={`footer-link-${link.label.toLowerCase().replace(/\s/g, "-")}`}
                  className="text-white text-sm hover:text-red-500 transition-colors font-light"
                  style={{ fontFamily: "'Raleway', sans-serif" }}
                >
                  {link.label}
                </Link>
              ))}
            </div>
          </div>

          {/* Contact */}
          <div>
            <h4
              className="text-sm tracking-[0.2em] uppercase mb-6 text-red-600 font-semibold"
              style={{ fontFamily: "'Raleway', sans-serif" }}
            >
              Contact
            </h4>
            <div className="flex flex-col gap-4">
              <a
                href="tel:0761712940"
                data-testid="footer-phone"
                className="flex items-center gap-3 text-white text-sm hover:text-red-500 transition-colors font-light"
              >
                <Phone className="w-4 h-4 text-red-600 flex-shrink-0" />
                0761 712 940
              </a>
              <a
                href="mailto:l.esko@yahoo.com"
                data-testid="footer-email"
                className="flex items-center gap-3 text-white text-sm hover:text-red-500 transition-colors font-light"
              >
                <Mail className="w-4 h-4 text-red-600 flex-shrink-0" />
                l.esko@yahoo.com
              </a>
              <div className="flex items-center gap-3 text-white text-sm font-light">
                <MapPin className="w-4 h-4 text-red-600 flex-shrink-0" />
                Râmnicu Sărat, Județul Buzău
              </div>
            </div>
          </div>
        </div>

        {/* Bottom */}
        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-white text-xs font-light" style={{ fontFamily: "'Raleway', sans-serif" }}>
            &copy; {new Date().getFullYear()} LSK Auto Styling Center. Toate drepturile rezervate.
          </p>
          <div className="flex items-center gap-6">
            <a
              href="https://www.facebook.com/lskautostyling/"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-facebook"
              className="text-white hover:text-red-500 transition-colors text-sm font-light"
            >
              Facebook
            </a>
            <span className="text-white text-xs font-light">lskauto.ro</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
